<template>
    <footer>
        <div class="container pt-5 pb-5">
            <div class="row">
                <div class="col-md-6">
                    <address>
                        <router-link :to="{ name: 'Index'}" class="brand">
                            VEILIGHEIDS<span class="primary">TEAM</span>.NL
                        </router-link><br />
                        Endegeesterstraatweg 3<br />
                        2342 AJ OEGSTGEEST<br />
                        <br />
                        <abbr title="WhatsApp" class="primary"><font-awesome-icon :icon="['fab', 'whatsapp']"></font-awesome-icon></abbr>&nbsp;<a href="https://wa.me/31640000933" target="_blank">06-40000933</a><br />
                        <abbr title="Email" class="primary"><font-awesome-icon icon="envelope"></font-awesome-icon></abbr>&nbsp;<a href="mailto:info@veiligheidsteam.nl">info@veiligheidsteam.nl</a><br />
                        
                    </address>
                </div>
                <div class="col-md-6">
                    <ul>
                        <ol>
                            <router-link tag="a" :to="{ name: 'RiskAnalysis' }"><h4>Gratis Risicoscan</h4></router-link>
                        </ol>
                        <ol>
                            <router-link tag="a" :to="{ name: 'Partners' }"><h4>Partners</h4></router-link>
                        </ol>
                        <ol>
                            <router-link tag="a" :to="{ name: 'Contact' }"><h4>Contact</h4></router-link>
                        </ol>
                    </ul>
                </div>
            </div>
        </div>
        <div class="foot">
            <div class="col-md-12 p-2 pl-5 pr-5">
                <strong>&copy; {{new Date().getFullYear()}} - </strong><span class="brand">VEILIGHEIDS<span class="primary">TEAM</span>.NL</span>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'the-footer',
}
</script>

<style scoped lang="scss">
@import "@/assets/styles.scss";

.foot {
    border-top: 1px solid $darkColor;
}
footer {
    border-top: 1px solid $primaryColor;
}

</style>